export const bankInformationFrontEnd = new Map([
  ['amex',
    {
      name: 'Amex',
      cards: new Map([
        ['gold_card',
          {
              name: 'Gold Card',
          },
        ],
        ['platinum_card',
          {
              name: 'Platinum Card',
          },
        ]
    ])
    }
  ],
  ['banamex',
    {
      name: 'Banamex',
      cards: new Map([
        ['clasica',
          {
            name: 'Clásica',
          },
        ],
        ['b_smart',
          {
            name: 'B Smart',
          },
        ],
        ['travel_pass',
          {
              name: 'Travel Pass',
          },
        ],
        ['oro',
          {
            name: 'Oro',
          },
        ],
        ['platinum',
          {
            name: 'Platinum',
          },
        ],
        ['rewards',
          {   
          name: 'Rewards',
          },
        ],
        ['premier',
          {
            name: 'Premier',
          },
        ]
      ])
    }
  ],
  ['banbajio',
    {
      name: 'BanBajio',
      cards: new Map([
        ['clasica',
          {
            name: 'Clásica',
          },
        ],
        ['platinum_internacional',
          {
            name: 'Platinum Internacional',
          },
        ],
      ]),
    }
  ],
  ['banorte',
    {
      name: 'Banorte',
      cards: new Map([
        ['clasica',
          {
            name: 'Clásica',
          },
        ],
        ['oro',
          {
            name: 'Oro',
          },
        ],
        ['platinum',
          {
            name: 'Platinum',
          },
        ]
      ])
    }
  ],
  ['bancomer',
    {
      name: 'Bancomer',
      cards: new Map([
        ['azul_bancomer',
          {
            name: 'Azul Bancomer',
          },
        ],
        ['congelada',
          {
            name: 'Congelada',
          },
        ],
        ['rayados_monterrey',
          {
            name: 'Rayados Monterrey',
          },
        ],
        ['oro_bancomer',
          {
            name: 'Oro Bancomer',
          },
        ],
        ['bancomer_platinum',
          {
            name: 'Bancomer Platinum',
          },
        ]
      ])
    }
  ],
  ['hsbc',
    {
      name: 'HSBC',
      cards: new Map([
        ['clasica_hsbc',
          {
            name: 'Clásica HSBC',
          },
        ],
        ['oro_hsbc',
          {
            name: 'Oro HSBC',
          },
        ],
        ['platinum_hsbc',
          {
            name: 'Platinum HSBC',
          },
        ]
      ])
    }
  ],
  ['inbursa',
    {
      name: 'Inbursa',
      cards: new Map([
        ['clasica_inbursa',
          {
            name: 'Clásica Inbursa',
          },
        ],
        ['oro_inbursa',
          {
            name: 'Oro Inbursa',
          },
        ],
        ['platinum_inbursa',
          {
            name: 'Platinum Inbursa',
          },
        ],
      ]),
    },
  ],
  ['invex',
    {
      name: 'Invex',
      cards: new Map([
        ['volaris_clasica',
          {
            name: 'Volaris Clásica',
          },
        ],
        ['volaris_oro',
          {
            name: 'Volaris Oro',
          },
        ],
        ['volaris_platinum',
          {
            name: 'Volaris Platinum',
          },
        ],
      ]),
    }
  ],
  ['ixe',
    {
      name: 'IXE',
      cards: new Map([
        ['clasica',
          {
            name: 'Clásica',
          },
        ],
        ['oro',
          {
            name: 'Oro',
          },
        ],
        ['ixe_platinum',
          {
            name: 'IXE Platinum',
          },
        ]
      ])
    }
  ],
  ['santander',
    {
      name: 'Santander',
      cards: new Map([
        ['santander_light',
          {
            name: 'Santander Light',
          },
        ],
        ['clasica',
          {
            name: 'Clásica',
          },
        ],
        ['black',
          {
            name: 'Black',
          },
        ],
        ['elite_rewards_clasica',
          {
            name: 'Elite Rewards Clásica',
          },
        ],
        ['uni_santander_k',
          {
            name: 'UNI Santander-K',
          },
        ],
        ['fiesta_rewards_platino',
          {
            name: 'Fiesta Rewards Platino',
          },
        ],
        ['elite_rewards_platino',
          {
            name: 'Elite Rewards Platino',
          },
        ],
      ]),
    }
  ],
  ['scotiabank',
    {
      name: 'Scotiabank',
      cards: new Map([
        ['tasa_baja_clasica',
          {
            name: 'Tasa Baja Clásica',
          },
        ],
        ['tradicional',
          {
            name: 'Tradicional',
          },
        ],
        ['basica',
          {
            name: 'Básica',
          },
        ],
        ['scotia_travel_oro',
          {
            name: 'Scotia Travel Oro',
          },
        ],
        ['tradicional_oro',
          {
            name: 'Tradicional Oro',
          },
        ],
        ['scotia_travel_platinum',
          {
            name: 'Scotia Travel Platinum',
          },
        ],
      ]),
    }
  ],
  ['credomatic',
    {
      name: 'Credomatic',
      cards: new Map([
        ['clasica_elite',
          {
            name: 'Clásica Elite',
          },
        ],
        ['gold_elite',
          {
            name: 'Gold Elite',
          },
        ],
        ['platinum_elite',
          {
            name: 'Platinum Elite',
          },
        ],
        ['galerias_elite',
          {
            name: 'Galerias Elite',
          },
        ],
        ['lowes_clasica',
          {
            name: "Lowe's Clásica",
          },
        ]
      ])
    }
  ]
]);
